export default __webpack_public_path__ + "static/media/triangle-pointer.4bd9355f.svg";